/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --status-color: var(--nve-sys-support-emphasis-color);
}

:host([status='muted']) {
  --status-color: var(--nve-sys-text-muted-color);
}

:host([status='accent']) {
  --status-color: var(--nve-sys-support-accent-emphasis-color);
}

:host([status='success']) {
  --status-color: var(--nve-sys-support-success-emphasis-color);
}

:host([status='warning']) {
  --status-color: var(--nve-sys-support-warning-emphasis-color);
}

:host([status='danger']) {
  --status-color: var(--nve-sys-support-danger-emphasis-color);
}
